import React from "react";
import { templateStrings } from "../../../Constant";
import { PageWrapper } from "../../../shared/layout";
import { getSettlementTemplateString } from "../../../shared/methods/sharedMethods";
import { BarLoader } from "../../../shared/widgets";
import DueGeneratedDetailsCard from "../settlement/DueGeneratedDetailsCard";
import "./dateDetail.css";
import DateDueWiseList from "./DateDueWiseList";

function DateDetailPage(props) {
  const {
    componentType = "not-operator", useStyleClasses, location, content,
    currentDueVehicles, totalItem,
  } = props;

  const operatorId = location?.state?.operatorId
    || "";
  const cityId = location?.state?.cityId
    || "";
  const operatorName = location?.state?.operatorName
    || "";
  let fromDate = location?.state?.date
    || "";
  const dueId = location?.state?.dueId
    || "";
  fromDate = new Date(fromDate);

  const gridStrings = props?.config
    && getSettlementTemplateString(
      props?.config,
      templateStrings.dateDetailCardGridItems,
    );

  return (
    <div className={useStyleClasses.root}>
      <PageWrapper>
        <PageWrapper.Header
          heading={operatorName}
          hideS
          showBackArrow
          removeFilterOnly
          hideDivider
          hideLower
        />
        <PageWrapper.Body style={{ marginTop: 50 }}>
          <BarLoader scope="header" />
          {componentType === "not-operator" && (
            <DueGeneratedDetailsCard
              data={content}
              operatorId={operatorId}
              cityId={cityId}
              currentDueVehicles={currentDueVehicles}
              // isUpdated={this.settledDone}
              gridStrings={gridStrings || {}}
              // isLoading={dateDetailLoader}
            />
          )}
          <DateDueWiseList
            content={content.items}
            totalItem={totalItem}
            fromDate={fromDate}
            operatorId={operatorId}
            cityId={cityId}
            dueId={dueId}
          />
        </PageWrapper.Body>
      </PageWrapper>
    </div>
  );
}

export default DateDetailPage;
